import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IAdvertiser, IAdvertiserAgencyReport } from "./types/_advertiser";
import { ResponseData } from "./types/_public";
const api = new APIClient();

const path = '/advertiser-agencies';
const advertiserApi = {
  advertiserAgencyReport(params: any = {}): Promise<AxiosResponse<ResponseData<IAdvertiserAgencyReport[]>, any>> {
    const url = `/reports/advertiser-agency`;
    return api.get(url, params)
  },
  allAdvertisers(params: any = {}): Promise<AxiosResponse<ResponseData<IAdvertiser>, any>> {
    const url = `/masters/advertisers`;
    return api.get(url, params)
  },
}
export default advertiserApi;
